import React from 'react'
import { getLanguageObj, settings } from '../../helpers/UtilsHelper'
import HtmlParser from 'react-html-parser';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const currentMethod = 'Home - function';

const { app, icons, images, labels, tabs } = settings;
const { urls } = app?.backend;

export default function About({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    const sections = [
        {
            title: app?.about?.whatIsIt?.title?.[languageObj?.id],
            body: app?.about?.whatIsIt?.paragrap?.[languageObj?.id],
            icon: images?.appLogo,
            badgeText: labels?.information?.[languageObj?.id],
            badgeIcon: icons?.fasFa?.infoCircle,
            badgeColor: 'info',
        },
        {
            title: app?.about?.whatAreYouDoing?.title?.[languageObj?.id],
            body: app?.about?.whatAreYouDoing?.[languageObj?.id],
            icon: images?.icons?.categories,
            badgeText: labels?.process?.[languageObj?.id],
            badgeIcon: icons?.fasFa?.tasks,
            badgeColor: 'primary',
        },
        {
            title: app?.about?.advantage?.title?.[languageObj?.id],
            body: app?.about?.advantage?.paragrap?.[languageObj?.id],
            icon: images?.icons?.checkSquare,
            badgeText: labels?.advantages?.[languageObj?.id],
            badgeIcon: icons?.fasFa?.checkCircle,
            badgeColor: 'success',
        },
        {
            title: app?.about?.itIsSafe?.title?.[languageObj?.id],
            body: app?.about?.itIsSafe?.paragrap?.[languageObj?.id],
            icon: images?.icons?.dataProtection,
            badgeText: labels?.security?.[languageObj?.id],
            badgeIcon: icons?.fasFa?.shieldAlt,
            badgeColor: 'warning text-dark',
        },
    ];

    return (
        <div>
            <Menu viewName={'home'} process={'about'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.about?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.about?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            {sections.map((section, idx) => (
                                <div key={idx} className='col-12 col-lg-6 mb-4'>
                                    <div className='card border-0 shadow-lg login-card h-100 bg-trasnparent' >
                                        <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center'>
                                                    {/* Circular avatar container with contextual icon */}
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{
                                                            width: '45px',
                                                            height: '45px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                        <img alt='icon'
                                                            style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                            src={section.icon} />
                                                    </div>
                                                    {/* Title & Badge */}
                                                    <div className='d-flex flex-column'>
                                                        <span className='h6 mb-0 font-weight-bold text-dark'>{section.title}</span>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill badge-${section.badgeColor} px-2 py-1 text-uppercase`}
                                                                style={settings?.html?.badges?.micro}>
                                                                <i className={`${section.badgeIcon} mr-1`}></i> {section.badgeText}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Card Widget Tools */}
                                                <div className='card-tools'>
                                                    <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                        <i className={icons?.fasFa?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Card Body */}
                                        <div className='card-body px-4 pb-4' style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                            {HtmlParser(`${tabs?.four} ${section.body}`)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </section>
            </div>
        </div>
    )
}